module.exports = __webpack_public_path__ + "img/Flag_of_Spain.e511dcee.svg";